export default "__VITE_ASSET__CUBg7PrV__"